var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "span",
      {
        staticClass: "icon u-clickable p-3",
        on: { click: _vm.updatePostGroupPostIdsRegistered },
      },
      [
        _vm.isRegistered
          ? _c("i", { staticClass: "fas fa-star has-text-warning" })
          : _c("i", { staticClass: "far fa-star has-text-grey" }),
      ]
    ),
    _vm._v(" "),
    _c("span", { staticClass: "p-3" }, [_vm._v(_vm._s(_vm.group.label))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }